module.exports = "<div id=\"main-wrapper\">\r\n\r\n  <app-header></app-header>\r\n  <app-sidebar></app-sidebar>\r\n\r\n  <div class=\"page-wrapper\">\r\n    <div class=\"container-fluid\">\r\n\r\n      <app-breadcumbs></app-breadcumbs>\r\n\r\n      <router-outlet></router-outlet>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<app-modal-upload></app-modal-upload>"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/pages/pages.component.html
// module id = ../../../../../src/app/pages/pages.component.html
// module chunks = main